import { Helmet } from 'react-helmet-async'
import { siteConfig } from '@/config/site'

interface SEOProps {
  title?: string
  description?: string
  keywords?: string[]
  image?: string
  url?: string
  type?: 'website' | 'article' | 'product'
  noIndex?: boolean
}

export function SEO({
  title,
  description = siteConfig.description,
  keywords = [
    'web design UK',
    'website builder',
    'small business website',
    'mobile app development',
    'SEO services UK',
    'digital marketing',
    'social media marketing',
    'UK web agency',
    'affordable websites',
    'business website design',
  ],
  image = `${siteConfig.url}/nexaigen-logo-agency.png`,
  url = siteConfig.url,
  type = 'website',
  noIndex = false,
}: SEOProps) {
  const fullTitle = title ? `${title} | ${siteConfig.name}` : `${siteConfig.name} - ${siteConfig.tagline}`

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(', ')} />
      <meta name="author" content={siteConfig.name} />
      <link rel="canonical" href={url} />

      {/* Robots */}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="500" />
      <meta property="og:image:height" content="500" />
      <meta property="og:site_name" content={siteConfig.name} />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Geographic */}
      <meta name="geo.region" content="GB" />
      <meta name="geo.placename" content="London" />

      {/* Mobile */}
      <meta name="format-detection" content="telephone=yes" />
      <meta name="theme-color" content="#6366f1" />
    </Helmet>
  )
}

export default SEO
